import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "MBotaoSelecionar__Opcao" }
const _hoisted_2 = { class: "MBotaoSelecionar__Rotulo light-text" }

import { computed } from "vue"
  import SelectButton from "primevue/selectbutton"
  import { Opcao } from "@/components/Gerais/index.d"

  interface Props {
    opcoes: Opcao[]
    modelValue: Opcao
  }
  interface Emitir {
    (event: "update:modelValue", modelValue: Opcao): void
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MBotaoSelecionar',
  props: {
    opcoes: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: Opcao): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    opcoes: Opcao[]
    modelValue: Opcao
  }

  
  

  const emitirModel = computed({
    get() {
      return props.modelValue
    },
    set(modelValue: Opcao) {
      if (!modelValue) {
        return
      }
      emitir("update:modelValue", modelValue)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectButton), {
    modelValue: _unref(emitirModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
    class: "MBotaoSelecionar",
    "data-testid": "MBotaoSelecionar",
    options: __props.opcoes
  }, {
    option: _withCtx(({ option }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("em", {
          class: _normalizeClass(["MBotaoSelecionar__Icone", option.icone])
        }, null, 2),
        _createElementVNode("div", _hoisted_2, _toDisplayString(option.rotulo), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})